import React, { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import logo from 'src/images/logo-sm.png';
import {
  Button,
  Collapse,
  Container,
  Icon,
  InputSelect,
  Link,
  Nav,
  Navbar,
  NavbarToggler,
  NavItem,
  useApp
} from 'straightline-ui';
import { ENTITY_TYPE } from 'straightline-utils/constants';

// Note that there is a NavLink reactstrap item. We do not use it,
// but create our own that wraps a react-router Link
const NavLink = ({ to, location, children }) => (
  <Link to={to} className={`nav-link ${location.pathname === to && 'active'}`}>
    {children}
  </Link>
);

export default function Sidebar() {
  const [open, setOpen] = useState(false);
  const history = useHistory();
  const location = useLocation();
  const app = useApp();

  const toggle = () => {
    setOpen(!open);
  };

  const close = () => {
    if (open) {
      setOpen(false);
    }
  };

  const back = () => {
    history.goBack();
  };

  return (
    <Navbar
      light
      expand="md"
      className="navbar-vertical fixed-left"
      id="sidebar"
    >
      <Container fluid>
        <Button
          color="link"
          className="py-1 px-2 text-dark d-block d-md-none"
          onClick={back}
        >
          <Icon type="chevron-left" />
        </Button>
        <Link className="navbar-brand" to="/">
          <img src={logo} className="navbar-brand-img mx-auto" alt="..." />
        </Link>
        <NavbarToggler onClick={toggle} />
        <Collapse navbar isOpen={open}>
          <AccountSwitcher />
          <hr className="my-3 d-none d-md-block" />
          <Nav navbar>
            <NavItem onClick={close}>
              <NavLink to="/dashboard" location={location}>
                <Icon type="home" /> Dashboard
              </NavLink>
            </NavItem>
            <NavItem onClick={close}>
              <NavLink to="/shipments" location={location}>
                <Icon type="package" /> Shipments
              </NavLink>
            </NavItem>
            <NavItem onClick={close}>
              <NavLink to="/quotes" location={location}>
                <Icon type="clipboard" /> Quotes
              </NavLink>
            </NavItem>
            <NavItem onClick={close}>
              <NavLink to="/invoices" location={location}>
                <Icon type="dollar-sign" /> Invoices
              </NavLink>
            </NavItem>
            <NavItem onClick={close}>
              <NavLink to="/addresses" location={location}>
                <Icon type="map" /> Addresses
              </NavLink>
            </NavItem>
            <NavItem onClick={close}>
              <NavLink to="/reports" location={location}>
                <Icon type="bar-chart" /> Reports
              </NavLink>
            </NavItem>
            <div className="px-4 mt-4">
              <Button to="/quote" color="primary" block>
                <Icon type="clipboard" className="mr-2" />
                Request Quote
              </Button>
            </div>
          </Nav>
          <div className="mt-auto">
            <hr className="my-3" />
            <Nav navbar className="mb-md-3">
              <NavItem onClick={close}>
                <NavLink to="/settings" location={location}>
                  <Icon type="settings" /> Settings
                </NavLink>
              </NavItem>
              <NavItem onClick={close}>
                <NavLink to="/support" location={location}>
                  <Icon type="send" /> Support
                </NavLink>
              </NavItem>
              <NavItem onClick={close}>
                <NavLink to="/guide" location={location}>
                  <Icon type="compass" /> Guide
                </NavLink>
              </NavItem>
              <NavItem>
                <div className="nav-link pointer" onClick={app.logout}>
                  <Icon type="log-out" /> Log Out
                </div>
              </NavItem>
            </Nav>
          </div>
        </Collapse>
      </Container>
    </Navbar>
  );
}

function AccountSwitcher() {
  const app = useApp();
  const tokens = app.auth.tokens.filter((token) => {
    return token.entity_type === ENTITY_TYPE.SHIPPER;
  });

  if (tokens.length === 1) {
    return null;
  }

  const token = app.auth.token;

  const options = tokens.map((token) => {
    return {
      label: token.entity_name,
      value: token.token
    };
  });

  const handleChange = async ({ target: { value } }) => {
    if (app.auth.token !== value) {
      window.sessionStorage.setItem('straightline-token', value);
      window.location.reload();
    }
  };

  return (
    <InputSelect value={token} options={options} onChange={handleChange} />
  );
}
